import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BlogHero from './components/BlogHero';
import FeaturedArticles from './components/FeaturedArticles';
import BlogCatalog from './components/BlogCatalog';
import NewsletterSection from './components/NewsletterSection';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const blogSchema = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: 'Blog de Tendencias Anthony Sánchez Couture',
  url: 'https://anthonysanchezc.com/blog',
  description: 'Artículos sobre moda, alta costura, tendencias y estilo personal. Consejos de nuestro atelier en Barcelona.',
  publisher: {
    '@type': 'LocalBusiness',
    name: 'Anthony Sánchez Couture',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      postalCode: '08008',
      addressCountry: 'ES',
    },
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Blog',
      item: 'https://anthonysanchezc.com/blog',
    },
  ],
};

export default function Blog() {
  useSEO({
    title: 'Blog de Moda | Alta Costura & Tendencias | Anthony Sánchez Couture Barcelona',
    description: 'Descubre los artículos de nuestro blog: tendencias de moda, consejos de estilo, historia de la alta costura y los secretos de nuestro atelier en Barcelona.',
    keywords: 'blog moda Barcelona, tendencias alta costura, estilo personal, moda 2025, consejos vestir, blog diseñador',
    canonical: '/blog',
    ogTitle: 'Blog de Moda — Alta Costura & Tendencias',
    ogDescription: 'Artículos sobre moda, alta costura y estilo personal desde nuestro atelier en Barcelona.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={blogSchema} />
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      <main>
        <BlogHero />
        <FeaturedArticles />
        <BlogCatalog />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
}